












import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonEditCancelTreament extends Vue {
  cancel = false;
  getRouteAddCustomer() {
    return this.$router.push("/treatments/database");
  }
  getRouteCancel() {
    return this.$router.push("/treatments/database");
  }
}
